import { Carousel, GetRef } from 'antd';
import React from 'react';
import { ICarouselProps } from './entities';

type CarouselRef = GetRef<typeof Carousel>;

const BCCarousel = React.forwardRef<{ ref: CarouselRef }, ICarouselProps>((props, ref) => {
	const carouselRef = React.useRef<CarouselRef>();

	React.useImperativeHandle(ref, () => ({
		ref: carouselRef.current
	}));

	return (
		<Carousel
			{...props}
			ref={carouselRef}
		>
			{props.children}
		</Carousel>
	);
});
export default BCCarousel;
export { ICarouselProps, CarouselRef };
